module.exports = __webpack_public_path__ + "d9dbaeed2ca04b170d0f7a88dd90ccf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/press_teaser_201602_hzdr.jpg
// module id = 640
// module chunks = 0